import React from 'react';

import Flex from '../StyledComponents/Flex';
import { isNullOrUndefined } from '../../utils';
import { useTranslation } from '@nic-react-i18n/core';
import dayjs from 'dayjs';

interface ItemInterface {
    icon?: string;
    label: string;
    style?: object;
    value: string | number | dayjs.Dayjs;
}

type ItemProps = ItemInterface

export const Item: React.FC<ItemProps> = (props) => {
    const {t} = useTranslation()
    let value: string;
    let formattingString = t('formatter.fullDate');

    if (!isNullOrUndefined(props.value)) {

        switch (typeof props.value) {
            case 'string':
            case 'number': {
                value = String(props.value);
                break;
            }
            default: {
                value = dayjs(props.value).format(formattingString);
            }
        }
    } else {
        value = t('value.undefined');
    }
    let icon = (!isNullOrUndefined(props.icon) ? <i className={props.icon} /> : null);

    return (
        <Flex
            direction={'row'}
            wrap={'wrap'}
            align={'center'}
            justify={'space-between'}
        >
            {icon}
            <span style={{fontWeight: 700, marginRight: '10px'}}>{props.label}:</span>
            <span style={props.style}>{value}</span>
        </Flex>
    );
};
